/*
 * @Author: jiangxd
 * @Date: 2021-08-04 11:24:02
 * @LastEditTime: 2021-08-04 11:44:12
 * @LastEditors: jiangxd
 * @Description:
 * @FilePath: /rs_ips_maintence/src/views/components/shopDisplaySketchMap/displayEdit/video.tsx
 */
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import style from './style.vue';

@Component({
  components: {},
  mixins: [style],
})
export default class VideoEdit extends Vue {
  @Prop({ default: () => {} })
    value: DisplayVideoData;

  @Prop({ default: false })
    disabled: boolean;

  data: DisplayVideoData = {};

  @Watch('value', { deep: true, immediate: true })
  watchValue(n, o) {
    if (JSON.stringify(n) !== JSON.stringify(o)) {
      this.data = n;
    }
  }

  @Watch('data', { deep: true })
  watchData() {
    this.$emit('input', this.data);
  }

  render(h) {
    return (
      <div class="container margin-top-none" key={this.data.sort} style="margin: 20px">
        {/* <el-radio-group v-model={value.desc.type} style="padding-bottom: 12px">
      <el-radio label={1} disabled>
        腾讯视频(推荐)
      </el-radio>
      <el-radio label={2}>普通视频</el-radio>
    </el-radio-group>
    <p class="tip">
      注：使用腾讯视频无需申请相关视频资质，如需去除广告/水印，需购买相关服务。
      <span class="scopeSpan" onClick={() => this.openNewWindow(value.desc.type)}>
        点此了解详情
      </span>
    </p>
    <div>&nbsp;</div>
    <p class="blockTitle config-title">
      视频地址 <span class="redText">*</span>
    </p>
    <el-form model={value} label-width="0">
      <el-form-item
        prop={`desc.url`}
        rules={{ required: true, message: "请输入地址", trigger: "blur" }}
        ref="form">
        <el-input v-model={value.desc.url}></el-input>
      </el-form-item>
    </el-form>
    <p class="blockTitle config-title" style="padding-bottom: 12px">
      是否自动播放
    </p>
    <el-radio-group v-model={value.desc.autoType}>
      <el-radio label={1}>不自动播放</el-radio>
      <br />
      <el-radio label={2} style="padding: 12px 0">
        仅在wi-fi环境下自动播放
      </el-radio>
      <br />
      <el-radio label={3}>始终自动播放</el-radio>
    </el-radio-group> */}
        <el-form props={{ model: this.data }} ref="form" class="video-form" disabled={this.disabled}>
          <el-form-item label="视频位名称" prop={'desc.vName'} rules={{ required: true, message: ' ', trigger: 'blur' }}>
            <el-input v-model={this.data.desc.vName} style="width: 260px" maxlength={10}></el-input>
          </el-form-item>
          <p class="tip">注: 配置了视频位后请前往店铺展示管理中追加相关视频</p>
        </el-form>
      </div>
    );
  }
}
